module.exports = __webpack_public_path__ + "static/media/times.1fe78667.svg";